<template>

  <div id="wrapper">
    <transition appear>
      <site-header></site-header>
    </transition>
    <router-view></router-view>
    <transition appear>
      <site-footer></site-footer>
    </transition>
  </div>

</template>

<script>
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import SiteFooter from './Global/SiteFooter'
import SiteHeader from './Global/SiteHeader'

UIkit.use(Icons)

export default {
  name: 'Layout',
  components: {SiteHeader, SiteFooter},
  data () {
    return {
      loading: 0
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";

svg {
  #pfeifen {
    * {
      fill: #ffffff;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue